import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import StripePaymentElementField from 'components/core/payment/stripe/payment_element';
import { subscriptionProviderSelector } from 'features/billing/selectors';
import { ChangeCardContainer, CreditCardField } from './styles';
import { useVatFlagAndCountryEnabled } from '../../../../hooks/feature_flags/use_vat_flag_and_country_enabled';
import { billingAddressCountrySelector } from '../../stages/paid_stage/billing_information_card/selectors';
const styledBareButtonCss = "s1wfqmf0";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
const addressChangeInfoCss = "a15yqaxg";
const AddressChangeInfo = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(addressChangeInfoCss, props.className)} />;
});
const ChargeBeeCardElement = ({
  onChange,
  onReady,
  onEscape,
  error
}) => <>
    <CreditCardField onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} />
    <AddressChangeInfo>
      {I18n.t('publisher.billing.change_plan.address_change_disclaimer')}
    </AddressChangeInfo>
  </>;
const StripePaymentElement = ({
  onChange,
  onReady,
  onEscape,
  error
}) => <>
    <StripePaymentElementField onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} />
    <AddressChangeInfo>
      {I18n.t('publisher.billing.change_plan.address_change_disclaimer')}
    </AddressChangeInfo>
  </>;
export const ChangeCard = ({
  expanded,
  error,
  onChange,
  onExpand,
  onEscape,
  onReady = () => {},
  onSubmit = () => {},
  ...props
}) => {
  const billingAddressCountry = useSelector(billingAddressCountrySelector);
  const shouldShowVatFlow = useVatFlagAndCountryEnabled(billingAddressCountry);
  const provider = useSelector(subscriptionProviderSelector);
  const isStripeProvider = provider === 'stripe';
  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(event);
  };
  if (shouldShowVatFlow) {
    if (!expanded) {
      return <div>
          <StyledBareButton as="a" onClick={onExpand}>
            {I18n.t('publisher.billing.change_plan.change_card')}
          </StyledBareButton>
        </div>;
    }
    return <div>
        <form onSubmit={handleSubmit}>
          <div>
            {isStripeProvider ? <StripePaymentElement onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} /> : <ChargeBeeCardElement onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} />}
          </div>
        </form>
      </div>;
  }
  if (!expanded) {
    return <form onSubmit={handleSubmit}>
        <ChangeCardContainer {...props}>
          <Button decoration="secondary-outline" size="small" onClick={onExpand}>
            {I18n.t('publisher.billing.change_plan.change_card')}
          </Button>
        </ChangeCardContainer>
      </form>;
  }
  return <form onSubmit={handleSubmit}>
      <ChangeCardContainer {...props} isExpanded>
        {isStripeProvider ? <StripePaymentElement onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} /> : <ChargeBeeCardElement onChange={onChange} onReady={onReady} onEscape={onEscape} error={error} />}
      </ChangeCardContainer>
    </form>;
};

require("./change_card.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./change_card.js");